import { Inject, Injectable, Injector } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { BehaviorSubject, Observable, catchError, filter, map, switchMap, take, throwError, timer } from 'rxjs';
import { AuthService } from './auth.service';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';


@Injectable({
  providedIn: 'root'
})
export class ApiService {

  private apiUrl = environment.govnet;
  private apiUrlGetter = environment.getterLink;


  // private readonly intervalDuration = 10 * 60 * 1000 + 30 * 1000; // 14 min and 30 sec
  // private nextCallTimeKey = 'next_api_call_time';
  // private initializationComplete = new BehaviorSubject<boolean>(false);

  lang:string;

  constructor(private http: HttpClient,private authService:AuthService
    ,private inject:Injector,private cookieService:CookieService) {

      this.lang=this.cookieService.get('lang');
      //this.lang="ar";

  }


  // initializeTimer(): void {
    
  //   const now = Date.now();
  //   let nextCallTime = parseInt(localStorage.getItem(this.nextCallTimeKey)!, 10);

  //   if(localStorage.getItem(this.nextCallTimeKey) == null){
  //     if (!nextCallTime || nextCallTime < now) {

  //       nextCallTime = now + this.intervalDuration;
  //       localStorage.setItem(this.nextCallTimeKey, nextCallTime.toString());
  //     }
  //   }
  
  //   const delay = nextCallTime - now ;

  //   timer(delay, this.intervalDuration).pipe(
  //     switchMap(() => this.callRefreshToeknApi())
  //   ).subscribe(response=>{
      

  //     if(response.statusCode==200){
  //       this.authService.setToken(response.data.id_token);
  //       this.authService.setAccessToken(response.data.access_token);
  //       this.authService.setRefreshToken(response.data.refresh_token);
  //     }else if(response.statusCode==400 || response.statusCode==401){
  //       this.authService.removeToken();
  //       location.href="/Investment/LoginPage";
  //     }

  //   });

  //   setTimeout(() => {
  //     this.initializationComplete.next(true);
  //   }, 2000);

  // }

  
  // public callRefreshToeknApi(): Observable<any> {
  //   const nextCallTime = Date.now() + this.intervalDuration;
  //   localStorage.setItem(this.nextCallTimeKey, nextCallTime.toString());

  //   return  this.http.post(`${environment.govnet}/auth/RefreshToken`, { "refreshToken" : this.authService.getRefreshToken() });
  // }

  // GET request
  get(endpoint: string,apiUrl:string=this.apiUrl, headers?: HttpHeaders,token:string=""): Observable<any> {
    const url = `${apiUrl}/${endpoint}`;

    if(!headers){

       headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin':'*',
        'Accept-Language':this.lang=="ar" ? 'ar-JO' : 'en-US',
        'Authorization': token!='' ? `Bearer ${token}` : this.authService.getToken() != undefined ? `Bearer ${this.authService.getToken()}` : '',
      });
    }


    



    return this.http.get<any>(url,{headers});

    // return this.initializationComplete.pipe(
    //   filter(initialized => initialized),
    //   take(1),
    //   switchMap(() => {
    //     const headers = this.createHeaders();
    //     return this.http.get<any>(`${apiUrl}/${endpoint}`, { headers });
    //   })
    // );

  }


  getTest(apiUrl:string=this.apiUrl, headers?: HttpHeaders,token:string=""): Observable<any> {
    const url = `${apiUrl}`;

    if(!headers){

       headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin':'*',
        //'Password':'S@vCh5wk#K~cW>*A}a9T3UE`h,ZDK*k8v?sA&w+dB7sKz.g,]7p%4/(WvVq~{PX4C^HM+Z)~2/<dYp:;$gf',
        'Accept-Language':this.lang=="ar" ? 'ar-JO' : 'en-US',
        'Authorization': token!='' ? `Bearer ${token}` : this.authService.getToken() != undefined ? `Bearer ${this.authService.getToken()}` : '',
      });
    }


    



    return this.http.get<any>(url,{headers});

    // return this.initializationComplete.pipe(
    //   filter(initialized => initialized),
    //   take(1),
    //   switchMap(() => {
    //     const headers = this.createHeaders();
    //     return this.http.get<any>(`${apiUrl}/${endpoint}`, { headers });
    //   })
    // );

  }


  postTest( data: any,apiUrl:string=this.apiUrl, headers?: HttpHeaders,token:string=""): Observable<any> {
    
    const url = `${apiUrl}`;

    if (!headers) {
      headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin':'*',
        //'Password':'S@vCh5wk#K~cW>*A}a9T3UE`h,ZDK*k8v?sA&w+dB7sKz.g,]7p%4/(WvVq~{PX4C^HM+Z)~2/<dYp:;$gf',
        'Accept-Language':this.lang=="ar" ? 'ar-JO' : 'en-US',
        'Authorization': token!='' ? `Bearer ${token}` : this.authService.getToken() != undefined ? `Bearer ${this.authService.getToken()}` : '',
      });
    }

    return this.http.post(url, data, { headers });

   }

  


  post(endpoint: string, data: any,apiUrl:string=this.apiUrl, headers?: HttpHeaders,token:string=""): Observable<any> {
    
    const url = `${apiUrl}/${endpoint}`;

    if (!headers) {
      headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin':'*',
        'Accept-Language':this.lang=="ar" ? 'ar-JO' : 'en-US',
        'Authorization': token!='' ? `Bearer ${token}` : this.authService.getToken() != undefined ? `Bearer ${this.authService.getToken()}` : '',
      });
    }

    return this.http.post(url, data, { headers });

   }


   postGetter(endpoint: string, data: any,apiUrl:string=this.apiUrl, headers?: HttpHeaders): Observable<any> {
    
    const url = `${this.apiUrlGetter}/${endpoint}`;

    if (!headers) {
      headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin':'*',
        'Accept-Language':this.lang=="ar" ? 'ar-JO' : 'en-US',
        'Authorization': this.authService.getToken() != undefined ? `Bearer ${this.authService.getToken()}` : '',
      });
    }

    return this.http.post(url, data, { headers });

   }

   
   getGetter(endpoint: string,apiUrl:string=this.apiUrl, headers?: HttpHeaders): Observable<any> {
    const url = `${this.apiUrlGetter}/${endpoint}`;

    if (!headers) {
      headers = new HttpHeaders({
        'accept': 'text/plain',
        'Authorization': this.authService.getToken() != undefined ? `Bearer ${this.authService.getToken()}` : '',
      });
    }
    return this.http.get<any>(url,{headers});

   }

   updateData(endpoint: string, data: any, apiUrl: string = this.apiUrl, headers?: HttpHeaders): Observable<any> {
    const url = `${this.apiUrlGetter}/${endpoint}`;
  
    // إذا لم يتم تمرير رؤوس (headers)، نستخدم رؤوس افتراضية
    if (!headers) {
      headers = new HttpHeaders({
        'accept': 'text/plain',
        'Content-Type': 'application/json-patch+json',  // تأكد من أن نوع المحتوى صحيح
        'Authorization': this.authService.getToken() != undefined ? `Bearer ${this.authService.getToken()}` : '',
      });
    }
  
    // إرسال البيانات باستخدام PUT
    return this.http.put<any>(url, data, { headers });
  }
  

    // return this.initializationComplete.pipe(
    //   filter(initialized => initialized),
    //   take(1),
    //   switchMap(() => {
    //     const headers = this.createHeaders();
    //     return this.http.post(`${apiUrl}/${endpoint}`, data, { headers });
    //   })
    // );
  

  customGet(endpoint: string,apiUrl:string,headers?: HttpHeaders): Observable<any> {
    const url = `${apiUrl}/${endpoint}`;

    return this.http.get(url, { headers });
    
  }

  minioRedirectFile(objectId:string){

    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin':'*',
      'Accept-Language':this.lang=="ar" ? 'ar-JO' : 'en-US',
      'Authorization': this.authService.getToken() != undefined ? `Bearer ${this.authService.getToken()}` : '',
    });

    const requestOptions = {
      headers: headers,
      observe: 'response' as 'response',
      responseType: 'blob' as 'blob'
    };

    this.http.get(`${environment.govnet}/Minio/RedirectFile/${encodeURIComponent(objectId)}`, requestOptions).subscribe(
      (response: HttpResponse<Blob>) => {

        const finalUrl = response.url!;

        window.open(finalUrl,'_blank');

      },
      (error: HttpErrorResponse) => {
        console.error('Error downloading file:', error.message);
      }
    );
  }

  



  userFromIdm(data:any):Observable<any>{
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin':'*',
      'Accept-Language':this.lang=="ar" ? 'ar-JO' : 'en-US',
      'idm-token':data.access_token,
      'Authorization': data.id_token,
    });


    var body={
      "deviceToken": ""
    }

    var request= this.post('auth/UserFromIdm',body,environment.govnet,headers);

    return request;

  }

  // login(username:string,password:string): Observable<HttpResponse<any>> {
    
  //   const url = `https://${environment.idm}/mga/sps/oauth/oauth20/token`;

  //   const formData = new FormData();


  //   const body = new HttpParams()
  //   .set('grant_type','password')
  //   .set('client_secret','k22DtPUNkpFbO3JqCDwn')
  //   .set('client_id','HrFZUo8o6dg4gUDzkYAi')
  //   .set('username',username)
  //   .set('password',password)
  //   .set('scope','openid');

  //   const httpOptions = {
  //     headers: new HttpHeaders({
  //       'Content-Type': 'application/x-www-form-urlencoded',
  //       "Access-Control-Allow-Origin": "*",
  //     }),
  //     observe: 'response' as const
  //   };

  //   return this.http.post<HttpResponse<any>>(url, body.toString(), httpOptions);
  // }

  uploadFile(file: File,carbonCopyId:string){
    debugger;

    const formData = new FormData();
    formData.append('Id',carbonCopyId);
    formData.append('File', file);

    const httpOptions = {
      headers: new HttpHeaders({
        'enctype': 'multipart/form-data',
        'Accept-Language':'en-US',
        'Authorization': this.authService.getToken()!=undefined ? `Bearer ${this.authService.getToken()}` :'',
      })
    };

    return this.http.post(`${environment.govnet}/Minio/UploadFile`, formData, httpOptions)
      .pipe(
        map(response => {
          // Handle your response here
          return response;
        }),
        catchError(error => {
          console.error(error);
          return [false];
        })
      );
  }

    
}


